import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {BehaviorSubject} from 'rxjs/Rx';

@Injectable()
export class LoadingService {

  private hidden: BehaviorSubject<boolean> = new BehaviorSubject(true);

  constructor() {
  }

  public showLoader() {
    this.hidden.next(false);
    return false;
  }

  public hideLoader() {
    this.hidden.next(true);
    return true;
  }

  getHiddenValue() {
    return new Observable(fn => this.hidden.subscribe(fn));
  }
}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/core/services/loading.service.ts